import { animate, style, transition, trigger } from '@angular/animations';

export const listItem = trigger('listItem', [
  transition(':enter', [
    style({ transform: 'translateY(10px)', opacity: 0 }),
    animate('200ms ease-in', style({ transform: 'translateY(0)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0)', opacity: 1 }),
    animate(
      '200ms ease-in',
      style({ transform: 'translateX(10%)', opacity: 0 })
    ),
  ]),
]);
